// Programs data with all 19 degree programs and their courses
export const programsData = [
  {
    id: 'bph',
    name: 'Bachelor of Public Health',
    shortName: 'BPH',
    category: 'Health Sciences',
    description: 'Comprehensive training in epidemiology, biostatistics, health policy, and community health interventions.',
    image: 'https://images.unsplash.com/photo-1679134015772-943d09a750ae?w=800',
    semesters: [
      {
        name: 'Semester 1',
        title: 'Introduction to Public Health and Basic Research Skills',
        courses: [
          { code: 'PUBH 101', name: 'Introduction to Public Health', credits: 3 },
          { code: 'EPID 101', name: 'Introduction to Epidemiology', credits: 3 },
          { code: 'ENGL 101', name: 'English Grammar and Academic Writing I', credits: 3 },
          { code: 'BIOL 101', name: 'Fundamentals of Biology', credits: 4 },
          { code: 'MATH 101', name: 'Foundations of Mathematics', credits: 3 },
          { code: 'CEPRES 101', name: 'Introduction to University Studies', credits: 3 },
        ]
      },
      {
        name: 'Semester 2',
        title: 'Epidemiology and Biostatistics',
        courses: [
          { code: 'BIOSTATS 104', name: 'Fundamentals of Biostatistics', credits: 3 },
          { code: 'RM 103', name: 'Foundations in Research Methods', credits: 3 },
          { code: 'PUBH 107', name: 'Technology in Health Sciences', credits: 3 },
          { code: 'ENGL 102', name: 'English Grammar and Academic Writing II', credits: 3 },
          { code: 'MATH 102', name: 'Trigonometry and Advanced Mathematics', credits: 3 },
          { code: 'PBL 1', name: 'PBL Scenario 1: Identifying Health Disparities', credits: 2 },
        ]
      },
      {
        name: 'Semester 3',
        title: 'Social and Behavioral Sciences in Public Health',
        courses: [
          { code: 'PUBH 201', name: 'Social Determinants of Health', credits: 3 },
          { code: 'HEED 203', name: 'Behavioral Sciences in Public Health', credits: 3 },
          { code: 'COMH 205', name: 'Applied Community Health Research', credits: 3 },
          { code: 'OPD 207', name: 'Online Professional Development I', credits: 3 },
          { code: 'GLOH 209', name: 'Contemporary Issues in Global Health', credits: 2 },
          { code: 'PBL 2', name: 'PBL Scenario 2: Community Intervention Program', credits: 2 },
        ]
      },
      {
        name: 'Semester 4',
        title: 'Environmental Health and Policy',
        courses: [
          { code: 'ENVH 101', name: 'Environmental Health', credits: 3 },
          { code: 'PUBH 204', name: 'Disaster Management in Public Health', credits: 3 },
          { code: 'IDSR 206', name: 'Integrated Disease Surveillance Response', credits: 3 },
          { code: 'OPD 208', name: 'Online Professional Development II', credits: 3 },
          { code: 'HEcon 210', name: 'Introduction to Health Economics', credits: 3 },
          { code: 'DCT 212', name: 'Data Collection Techniques', credits: 3 },
        ]
      },
      {
        name: 'Semester 5',
        title: 'Global Health and Disease Management',
        courses: [
          { code: 'PUBH 301', name: 'Advanced First Aid', credits: 3 },
          { code: 'OHS 101', name: 'Introduction to Occupational Health & Safety', credits: 3 },
          { code: 'ENTP 303', name: 'Entrepreneurship & Innovation', credits: 3 },
          { code: 'PHC 305', name: 'Introduction to Primary Health Care', credits: 3 },
          { code: 'EPID 307', name: 'Outbreak Investigation and Response', credits: 3 },
          { code: 'PBL 3', name: 'PBL Scenario 3: Implementing Intervention', credits: 2 },
        ]
      },
      {
        name: 'Semester 6',
        title: 'Capstone Project and Applied Learning',
        courses: [
          { code: 'CP 302', name: 'Capstone Project Preparation', credits: 3 },
          { code: 'HADM 101', name: 'Introduction to Health Administration', credits: 3 },
          { code: 'COMH 306', name: 'Health Policy and Legislation', credits: 2 },
          { code: 'PBL 4', name: 'PBL Scenario 4: Health Promotion Campaign', credits: 2 },
          { code: 'PUBH 308', name: 'Future Trends in Public Health', credits: 2 },
          { code: 'COMH 310', name: 'Cross-Cultural Competence in Healthcare', credits: 3 },
        ]
      },
      {
        name: 'Semester 7',
        title: 'Academic Writing & Communication',
        courses: [
          { code: 'ENGL 401', name: 'Academic Writing and Publication', credits: 4 },
          { code: 'PUBH 403', name: 'Professional Development in Public Health', credits: 3 },
          { code: 'COMH 405', name: 'Program Planning and Evaluation', credits: 3 },
          { code: 'HEED 405', name: 'Health Education Program Planning', credits: 3 },
          { code: 'COMH 409', name: 'Community Mobilization and Entry', credits: 3 },
          { code: 'HEED 409', name: 'Clinical Teaching Seminar', credits: 2 },
        ]
      },
      {
        name: 'Semester 8',
        title: 'Integration and Professional Development',
        courses: [
          { code: 'CP 402', name: 'Capstone Project', credits: 6 },
          { code: 'INTP 404', name: 'Field Experience (Internship)', credits: 6 },
          { code: 'PUBL 406', name: 'Final Publication', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bch',
    name: 'Bachelor of Community Health',
    shortName: 'BCH',
    category: 'Health Sciences',
    description: 'Focus on community health assessment, disease surveillance, and behavioral change strategies.',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800',
    semesters: [
      {
        name: 'Semester 1',
        title: 'Introduction to Community Health',
        courses: [
          { code: 'COMH 101', name: 'Introduction to Community Health', credits: 3 },
          { code: 'BIOL 101', name: 'Fundamentals of Biology', credits: 4 },
          { code: 'ENGL 101', name: 'English Grammar and Academic Writing I', credits: 3 },
          { code: 'MATH 101', name: 'Foundations of Mathematics', credits: 3 },
          { code: 'PUBH 101', name: 'Introduction to Public Health', credits: 3 },
          { code: 'CEPRES 101', name: 'Introduction to University Studies', credits: 3 },
        ]
      },
      {
        name: 'Semester 2',
        title: 'Technology in Community Health',
        courses: [
          { code: 'BIOSTATS 104', name: 'Fundamentals of Biostatistics', credits: 3 },
          { code: 'RM 103', name: 'Foundations in Research Methods', credits: 3 },
          { code: 'PUBH 107', name: 'Technology in Health Sciences', credits: 3 },
          { code: 'ENGL 102', name: 'English Grammar and Academic Writing II', credits: 3 },
          { code: 'MATH 102', name: 'Trigonometry and Advanced Mathematics', credits: 3 },
          { code: 'PBL 1', name: 'PBL Scenario 1: Identifying Health Disparities', credits: 2 },
        ]
      },
      {
        name: 'Semester 3',
        title: 'Community Health Assessment and Research',
        courses: [
          { code: 'COMH 201', name: 'Advanced First Aid', credits: 3 },
          { code: 'HEED 203', name: 'Behavioral Sciences in Public Health', credits: 3 },
          { code: 'COMH 205', name: 'Applied Community Health Research', credits: 3 },
          { code: 'OPD 207', name: 'Online Professional Development I', credits: 3 },
          { code: 'GLOH 209', name: 'Contemporary Issues in Global Health', credits: 3 },
          { code: 'PBL 2', name: 'PBL Scenario 2: Community Intervention', credits: 3 },
        ]
      },
      {
        name: 'Semester 4',
        title: 'Community Health Issues and Planning',
        courses: [
          { code: 'COMH 202', name: 'Community Health Assessment', credits: 3 },
          { code: 'COMH 204', name: 'Maternal and Child Health', credits: 3 },
          { code: 'IDSR 206', name: 'Integrated Disease Surveillance Response', credits: 3 },
          { code: 'OPD 208', name: 'Online Professional Development II', credits: 3 },
          { code: 'HEcon 210', name: 'Introduction to Health Economics', credits: 3 },
          { code: 'DCT 212', name: 'Data Collection Techniques', credits: 3 },
        ]
      },
      {
        name: 'Semester 5',
        title: 'Communication & Case Management',
        courses: [
          { code: 'ENTP 303', name: 'Entrepreneurship & Innovation', credits: 3 },
          { code: 'PBL 3', name: 'PBL Scenario 3: Implementing Intervention', credits: 2 },
          { code: 'PHC 305', name: 'Introduction to Primary Health Care', credits: 3 },
          { code: 'EPID 307', name: 'Outbreak Investigation and Response', credits: 3 },
          { code: 'COMH 309', name: 'Nutrition and Health', credits: 3 },
          { code: 'OHS 101', name: 'Introduction to Occupational Health & Safety', credits: 3 },
        ]
      },
      {
        name: 'Semester 6',
        title: 'Capstone Project and Applied Learning',
        courses: [
          { code: 'CP 302', name: 'Capstone Project Preparation', credits: 3 },
          { code: 'COMH 304', name: 'Community Health Leadership', credits: 2 },
          { code: 'COMH 306', name: 'Health Policy and Legislation', credits: 2 },
          { code: 'PBL 4', name: 'PBL Scenario 4: Health Promotion Campaign', credits: 3 },
          { code: 'PUBH 308', name: 'Future Trends in Public Health', credits: 2 },
          { code: 'COMH 310', name: 'Cross-Cultural Competence in Healthcare', credits: 3 },
        ]
      },
      {
        name: 'Semester 7',
        title: 'Academic Writing & Communication',
        courses: [
          { code: 'ENGL 401', name: 'Academic Writing and Publication', credits: 4 },
          { code: 'PUBH 403', name: 'Professional Development in Public Health', credits: 3 },
          { code: 'COMH 405', name: 'Program Planning and Evaluation', credits: 3 },
          { code: 'COMH 407', name: 'Sociology and Psychology of Health', credits: 2 },
          { code: 'COMH 409', name: 'Community Mobilization and Entry', credits: 3 },
          { code: 'COMH 411', name: 'Community Health Nursing', credits: 3 },
          { code: 'HEED 409', name: 'Clinical Teaching Seminar', credits: 3 },
        ]
      },
      {
        name: 'Semester 8',
        title: 'Integration and Professional Development',
        courses: [
          { code: 'CP 402', name: 'Capstone Project', credits: 6 },
          { code: 'INTP 404', name: 'Field Experience (Internship)', credits: 6 },
          { code: 'PUBL 406', name: 'Final Publication', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bsc-eb',
    name: 'BSc in Epidemiology and Biostatistics',
    shortName: 'BSc-EB',
    category: 'Health Sciences',
    description: 'Advanced training in epidemiological methods, biostatistics, and health data analysis.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=800',
    semesters: [
      {
        name: 'Semester 1',
        title: 'Introduction to Biostatistics and Epidemiology',
        courses: [
          { code: 'EPID 101', name: 'Introduction to Epidemiology', credits: 3 },
          { code: 'PUBH 101', name: 'Introduction to Public Health', credits: 3 },
          { code: 'BIOL 101', name: 'Fundamentals of Biology', credits: 4 },
          { code: 'ENGL 101', name: 'English Grammar and Academic Writing I', credits: 3 },
          { code: 'MATH 101', name: 'Foundations of Mathematics', credits: 3 },
          { code: 'CEPRES 101', name: 'Introduction to University Studies', credits: 3 },
        ]
      },
      {
        name: 'Semester 2',
        title: 'Foundations of Epidemiology',
        courses: [
          { code: 'BIOSTATS 104', name: 'Fundamentals of Biostatistics', credits: 3 },
          { code: 'RM 103', name: 'Foundations in Research Methods', credits: 3 },
          { code: 'PUBH 107', name: 'Technology in Health Sciences', credits: 3 },
          { code: 'ENGL 102', name: 'English Grammar and Academic Writing II', credits: 3 },
          { code: 'MATH 102', name: 'Trigonometry and Advanced Mathematics', credits: 3 },
          { code: 'PBL 1', name: 'PBL Scenario 1: Identifying Health Disparities', credits: 3 },
        ]
      },
      {
        name: 'Semester 3',
        title: 'Epidemiological Health Assessment',
        courses: [
          { code: 'CALS 201', name: 'Calculus for Health Professionals I', credits: 3 },
          { code: 'HEED 203', name: 'Behavioral Sciences in Public Health', credits: 3 },
          { code: 'EPID 205', name: 'First Step in Epidemiology', credits: 3 },
          { code: 'OPD 207', name: 'Online Professional Development I', credits: 3 },
          { code: 'GLOH 209', name: 'Contemporary Issues in Global Health', credits: 3 },
          { code: 'PBL 2', name: 'PBL Scenario 2: Community Intervention', credits: 3 },
        ]
      },
      {
        name: 'Semester 4',
        title: 'Outbreak Investigation & Data',
        courses: [
          { code: 'EPID 202', name: 'Measuring Health and Diseases', credits: 2 },
          { code: 'CALS 202', name: 'Calculus for Health Professionals II', credits: 3 },
          { code: 'IDSR 206', name: 'Integrated Disease Surveillance Response', credits: 3 },
          { code: 'OPD 208', name: 'Online Professional Development II', credits: 3 },
          { code: 'HEcon 210', name: 'Introduction to Health Economics', credits: 3 },
          { code: 'DCT 212', name: 'Data Collection Techniques', credits: 3 },
        ]
      },
      {
        name: 'Semester 5',
        title: 'Community Assessment and Intervention',
        courses: [
          { code: 'BIOSTATS 301', name: 'Intermediate Biostatistics', credits: 3 },
          { code: 'ENTP 303', name: 'Entrepreneurship & Innovation', credits: 3 },
          { code: 'PBL 3', name: 'PBL Scenario 3: Implementing Intervention', credits: 3 },
          { code: 'PHC 305', name: 'Introduction to Primary Health Care', credits: 3 },
          { code: 'EPID 307', name: 'Outbreak Investigation and Response', credits: 3 },
          { code: 'OHS 101', name: 'Introduction to Occupational Health & Safety', credits: 2 },
        ]
      },
      {
        name: 'Semester 6',
        title: 'Capstone Project and Applied Learning',
        courses: [
          { code: 'CP 302', name: 'Capstone Project Preparation', credits: 3 },
          { code: 'EPID 304', name: 'Epidemiological Study Designs', credits: 3 },
          { code: 'COMH 306', name: 'Health Policy and Legislation', credits: 2 },
          { code: 'PBL 4', name: 'PBL Scenario 4: Health Promotion Campaign', credits: 3 },
          { code: 'PUBH 308', name: 'Future Trends in Public Health', credits: 2 },
          { code: 'EPID 310', name: 'Longitudinal Studies in Epidemiology', credits: 3 },
        ]
      },
      {
        name: 'Semester 7',
        title: 'Academic Writing & Communication',
        courses: [
          { code: 'ENGL 401', name: 'Academic Writing and Publication', credits: 4 },
          { code: 'PUBH 403', name: 'Professional Development in Public Health', credits: 3 },
          { code: 'COMH 405', name: 'Program Planning and Evaluation', credits: 3 },
          { code: 'HEED 405', name: 'Health Education Program Planning', credits: 3 },
          { code: 'COMH 409', name: 'Community Mobilization and Entry', credits: 3 },
          { code: 'HEED 409', name: 'Clinical Teaching Seminar', credits: 2 },
        ]
      },
      {
        name: 'Semester 8',
        title: 'Integration and Professional Development',
        courses: [
          { code: 'CP 402', name: 'Capstone Project', credits: 6 },
          { code: 'INTP 404', name: 'Field Experience (Internship)', credits: 6 },
          { code: 'PUBL 406', name: 'Final Publication', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bsc-mlt',
    name: 'BSc in Medical Laboratory Technology',
    shortName: 'BSc-MLT',
    category: 'Health Sciences',
    description: 'Training in clinical laboratory science, microbiology, hematology, and diagnostic techniques.',
    image: 'https://images.unsplash.com/photo-1579165466741-7f35e4755660?w=800',
    semesters: [
      {
        name: 'Semester 1',
        title: 'Introduction to Medical Laboratory Science',
        courses: [
          { code: 'MLT FUND 101', name: 'Fundamentals of Medical Lab Technology I', credits: 4 },
          { code: 'CHEM 101', name: 'Basic Chemistry', credits: 4 },
          { code: 'ENGL 101', name: 'English Grammar and Academic Writing I', credits: 3 },
          { code: 'MATH 101', name: 'Laboratory Mathematics', credits: 3 },
          { code: 'A & P 106', name: 'Anatomy and Physiology I', credits: 4 },
          { code: 'CEPRES 101', name: 'Introduction to University Studies', credits: 3 },
        ]
      },
      {
        name: 'Semester 2',
        title: 'Deep Knowledge and Ethical Consideration',
        courses: [
          { code: 'MICRO 207', name: 'Clinical Microbiology I', credits: 4 },
          { code: 'A & P 107', name: 'Anatomy and Physiology II', credits: 3 },
          { code: 'PROF/ETHICS', name: 'Professional Ethics', credits: 2 },
          { code: 'ENGL 102', name: 'English Grammar and Academic Writing II', credits: 3 },
          { code: 'MLT FUND 102', name: 'Fundamentals of Medical Lab Technology II', credits: 3 },
          { code: 'PBL 1', name: 'PBL Scenario 1: Identifying Health Disparities', credits: 2 },
        ]
      },
      {
        name: 'Semester 3',
        title: 'Laboratory & Assessment',
        courses: [
          { code: 'MICRO 208', name: 'Clinical Microbiology II', credits: 4 },
          { code: 'PARA 221', name: 'Clinical Parasitology I', credits: 4 },
          { code: 'HEMA 213', name: 'Clinical Hematology/Coagulation I', credits: 4 },
          { code: 'OPD 208', name: 'Online Professional Development I', credits: 3 },
          { code: 'UBF 209', name: 'Urinalysis and Body Fluids', credits: 3 },
          { code: 'PBL 2', name: 'PBL Scenario 2: Community Intervention', credits: 2 },
          { code: 'CP 215', name: 'Clinical Practice I', credits: 0 },
        ]
      },
      {
        name: 'Semester 4',
        title: 'Dive Deep in Laboratory Science',
        courses: [
          { code: 'HEMA 214', name: 'Clinical Hematology/Coagulation II', credits: 4 },
          { code: 'PARA 222', name: 'Clinical Parasitology II', credits: 4 },
          { code: 'CHEM 231', name: 'Clinical Biochemistry', credits: 4 },
          { code: 'BBT 305', name: 'Blood Banking & Transfusion', credits: 3 },
          { code: 'IMMS 217', name: 'Immunology/Serology', credits: 3 },
          { code: 'CP 216', name: 'Clinical Practice II', credits: 0 },
        ]
      },
      {
        name: 'Semester 5',
        title: 'Laboratory Science & Community Engagement',
        courses: [
          { code: 'CTH 327', name: 'Cytology/Histology', credits: 3 },
          { code: 'LBM 341', name: 'Laboratory Management', credits: 2 },
          { code: 'PUBH 101', name: 'Introduction to Public Health', credits: 3 },
          { code: 'ENTP 303', name: 'Entrepreneurship & Innovation', credits: 3 },
          { code: 'PBL 3', name: 'PBL Scenario 3: Implementing Intervention', credits: 2 },
          { code: 'HADM 101', name: 'Introduction to Health Administration', credits: 3 },
          { code: 'CP 371', name: 'Clinical Practice III', credits: 0 },
        ]
      },
      {
        name: 'Semester 6',
        title: 'Application in Laboratory Technology',
        courses: [
          { code: 'CMP 380', name: 'Clinical Microbiology Practical', credits: 0 },
          { code: 'CPP 381', name: 'Clinical Parasitology Practical', credits: 0 },
          { code: 'CHP 382', name: 'Clinical Hematology/Coagulation Practical', credits: 0 },
          { code: 'UBP 383', name: 'Urinalysis & Body Fluids Practical', credits: 0 },
          { code: 'SIP 384', name: 'Serology/Immunology Practical', credits: 0 },
          { code: 'CHP 385', name: 'Cytology/Histology Practical', credits: 0 },
          { code: 'PBL 4', name: 'PBL Scenario 4: Health Promotion Campaign', credits: 2 },
          { code: 'CP 391', name: 'Clinical Practice IV', credits: 0 },
        ]
      },
    ]
  },
  {
    id: 'bhep',
    name: 'Bachelor of Health Education and Promotion',
    shortName: 'BHEP',
    category: 'Health Sciences',
    description: 'Training in health education strategies, behavior change, and health promotion programs.',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'HEED 101', name: 'Introduction to Health Education', credits: 3 },
          { code: 'HEED 201', name: 'Health Promotion and Disease Prevention', credits: 3 },
          { code: 'HEED 202', name: 'Cultural Competence in Health Education', credits: 2 },
          { code: 'HEED 204', name: 'Health Communication Strategies', credits: 3 },
          { code: 'HEED 301', name: 'VR and Simulation in Health Education', credits: 3 },
          { code: 'HEED 401', name: 'Innovative Technology Solutions', credits: 3 },
          { code: 'HEED 407', name: 'Health Informatics and EHR', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bohs',
    name: 'Bachelor of Occupational Health and Safety',
    shortName: 'BOHS',
    category: 'Health Sciences',
    description: 'Training in workplace health, safety management, industrial hygiene, and risk assessment.',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'OHS 101', name: 'Introduction to Occupational Health and Safety', credits: 3 },
          { code: 'OHS 205', name: 'Workplace Health Promotion', credits: 3 },
          { code: 'OHS 211', name: 'Industrial Hygiene', credits: 3 },
          { code: 'OHS 202', name: 'Safety Management Systems', credits: 2 },
          { code: 'OHS 206', name: 'Industrial Safety Engineering', credits: 3 },
          { code: 'OHS 309', name: 'Occupational Disease and Injury Prevention', credits: 3 },
          { code: 'OHS 405', name: 'Advanced Risk Management', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bha-admin',
    name: 'Bachelor of Health Administration',
    shortName: 'BHA-Admin',
    category: 'Health Sciences',
    description: 'Training in healthcare management, leadership, and health systems administration.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'HADM 101', name: 'Introduction to Health Administration', credits: 3 },
          { code: 'HADM 201', name: 'Principles of Management', credits: 3 },
          { code: 'HACC 101', name: 'Principles of Health Accounting', credits: 3 },
          { code: 'HADM 206', name: 'Health Information Systems', credits: 3 },
          { code: 'HADM 301', name: 'Medical Law and Ethics', credits: 2 },
          { code: 'HADM 309', name: 'Organizational Behavior in Healthcare', credits: 3 },
          { code: 'HADM 412', name: 'Health Marketing', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bsc-es',
    name: 'BSc in Environmental Science',
    shortName: 'BSc-ES',
    category: 'Environmental Sciences',
    description: 'Study of ecosystems, climate science, pollution control, and environmental management.',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'ENVS 101', name: 'Introduction to Environmental Science', credits: 3 },
          { code: 'ENVS 104', name: 'Climate Science', credits: 3 },
          { code: 'ENVS 107', name: 'Principles of Ecology', credits: 3 },
          { code: 'ENVS 201', name: 'Ecosystem Management', credits: 3 },
          { code: 'ENVS 301', name: 'Marine Biology', credits: 3 },
          { code: 'ENVS 305', name: 'GIS and Remote Sensing', credits: 3 },
          { code: 'ENVH 409', name: 'Renewable Energy and Sustainable Practices', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'beh',
    name: 'Bachelor of Environmental Health',
    shortName: 'BEH',
    category: 'Environmental Sciences',
    description: 'Focus on environmental factors affecting human health and environmental health administration.',
    image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'ENVH 101', name: 'Introduction to Environmental Health', credits: 3 },
          { code: 'ENVS 202', name: 'Environmental Pollution', credits: 3 },
          { code: 'ENVS 204', name: 'Water Science and Management', credits: 3 },
          { code: 'ENVH 302', name: 'Environmental Health Administration', credits: 3 },
          { code: 'ENVH 307', name: 'Bioinformatics in Environmental Health', credits: 3 },
          { code: 'ENVH 310', name: 'Environmental Economics', credits: 3 },
          { code: 'ENVH 403', name: 'Environmental Impact Assessment', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bpe',
    name: 'Bachelor of Primary Education',
    shortName: 'BPE',
    category: 'Education',
    description: 'Training in primary education pedagogy, child development, and teaching strategies.',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'PEDU 101', name: 'Introduction to Primary Education', credits: 3 },
          { code: 'PEDU 201', name: 'Introduction to Education Psychology', credits: 3 },
          { code: 'PEDU 203', name: 'Child Development and Learning', credits: 3 },
          { code: 'PEDU 205', name: 'Primary Education Pedagogy', credits: 3 },
          { code: 'PEDU 305', name: 'Integrated Science Instruction', credits: 3 },
          { code: 'PEDU 306', name: 'STEM Education in Primary Schools', credits: 3 },
          { code: 'PEDU 411', name: 'Assessment and Evaluation', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'beas',
    name: 'Bachelor of Educational Administration & Supervision',
    shortName: 'BEAS',
    category: 'Education',
    description: 'Training in educational leadership, school administration, and teacher supervision.',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'EDAD 101', name: 'Introduction to Education Administration', credits: 3 },
          { code: 'EDAD 203', name: 'Foundations of Educational Leadership', credits: 3 },
          { code: 'EDAD 202', name: 'School Finance and Resource Management', credits: 3 },
          { code: 'EDAD 301', name: 'Data-Driven Decision Making', credits: 2 },
          { code: 'EDAD 302', name: 'Supervisory Skills in Education', credits: 3 },
          { code: 'EDAD 304', name: 'Teacher Evaluation and Development', credits: 3 },
          { code: 'EDAD 407', name: 'Innovations in Educational Leadership', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bt',
    name: 'Bachelor of Teaching',
    shortName: 'BT',
    category: 'Education',
    description: 'Comprehensive training in teaching methodologies, classroom management, and subject instruction.',
    image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'BAT 101', name: 'Introduction to Teaching', credits: 3 },
          { code: 'BAT 203', name: 'Effective Teaching Strategies', credits: 3 },
          { code: 'BAT 204', name: 'Arts Integration in Teaching', credits: 3 },
          { code: 'BAT 301', name: 'Advanced Teaching Methods in Mathematics', credits: 3 },
          { code: 'BAT 302', name: 'Literary Analysis and PBL', credits: 3 },
          { code: 'BAT 308', name: 'Instructional Leadership', credits: 3 },
          { code: 'BAT 405', name: 'Innovations in Teaching Practices', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bem',
    name: 'Bachelor of Education Management',
    shortName: 'BEM',
    category: 'Education',
    description: 'Training in educational policy, marketing, technology integration, and strategic management.',
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'EDMG 101', name: 'Introduction to Education Management', credits: 3 },
          { code: 'EDMG 205', name: 'Supervision and Evaluation', credits: 3 },
          { code: 'EDMG 206', name: 'Education Policy Analysis and Advocacy', credits: 2 },
          { code: 'EDMG 301', name: 'Educational Marketing and Communication', credits: 3 },
          { code: 'EDMG 302', name: 'Data Analytics for Education', credits: 3 },
          { code: 'EDMG 403', name: 'Cross-Cultural Leadership', credits: 3 },
          { code: 'EDMG 405', name: 'Innovative Technology Solutions', credits: 2 },
        ]
      },
    ]
  },
  {
    id: 'bsc-pss',
    name: 'BSc in Plant and Soil Science',
    shortName: 'BSc-PSS',
    category: 'Agriculture',
    description: 'Study of plant physiology, soil science, crop management, and agricultural technology.',
    image: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'PASS 101', name: 'Introduction to Plant and Soil Science', credits: 3 },
          { code: 'PASS 107', name: 'Soil Composition and Structure', credits: 3 },
          { code: 'PASS 201', name: 'Cellular Processes in Plants', credits: 3 },
          { code: 'PASS 204', name: 'Precision Farming Technologies', credits: 3 },
          { code: 'PASS 302', name: 'IoT Applications in Agriculture', credits: 3 },
          { code: 'PASS 403', name: 'Machine Learning and AI for Precision Agriculture', credits: 3 },
          { code: 'PASS 411', name: 'Plant Genetics & Breeding', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bsc-sa',
    name: 'BSc in Sustainable Agriculture',
    shortName: 'BSc-SA',
    category: 'Agriculture',
    description: 'Sustainable farming, agroecology, food security, and agribusiness management.',
    image: 'https://images.unsplash.com/photo-1746014929708-fcb859fd3185?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'SUAG 101', name: 'Fundamentals of Sustainable Agriculture', credits: 3 },
          { code: 'SUAG 102', name: 'Agro-Technology Innovations', credits: 3 },
          { code: 'SUAG 201', name: 'Nutritional Agriculture', credits: 3 },
          { code: 'SUAG 204', name: 'Organic Farming and Agroecology', credits: 3 },
          { code: 'SUAG 301', name: 'Economic Aspects of Sustainable Agriculture', credits: 2 },
          { code: 'SUAG 405', name: 'Business Models for Sustainable Farms', credits: 3 },
          { code: 'SUAG 411', name: 'Ethical Considerations in Agribusiness', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bpa',
    name: 'Bachelor of Public Administration',
    shortName: 'BPA',
    category: 'Administration',
    description: 'Training in public sector management, policy analysis, and government administration.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'PADM 101', name: 'Introduction to Public Administration', credits: 3 },
          { code: 'PADM 203', name: 'Administrative Law', credits: 3 },
          { code: 'PADM 204', name: 'Introduction to Public Policy', credits: 3 },
          { code: 'PADM 301', name: 'Human Resource Management', credits: 3 },
          { code: 'PADM 309', name: 'Public Budgeting and Finance', credits: 3 },
          { code: 'PADM 407', name: 'Public Policy and Analysis', credits: 3 },
          { code: 'PADM 409', name: 'Change Management', credits: 2 },
        ]
      },
    ]
  },
  {
    id: 'bsc-pm',
    name: 'BSc in Project Management',
    shortName: 'BSc-PM',
    category: 'Administration',
    description: 'Training in project planning, agile methodologies, risk management, and certifications.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800',
    semesters: [
      {
        name: 'Semester 1-6',
        title: 'Complete 6-Semester Curriculum',
        courses: [
          { code: 'PMGT 101', name: 'Introduction to Project Management', credits: 3 },
          { code: 'PMGT 102', name: 'Project Management Tools and Techniques', credits: 3 },
          { code: 'PMGT 201', name: 'Advanced Project Management', credits: 3 },
          { code: 'PMGT 203', name: 'Agile Project Management', credits: 3 },
          { code: 'CERT 202', name: 'Google PM Certification Prep', credits: 3 },
          { code: 'CERT 204', name: 'PMP Certification Prep', credits: 3 },
          { code: 'GLOB 304', name: 'Global Project Management', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bha',
    name: 'Bachelor of Health Accounting',
    shortName: 'BHA',
    category: 'Finance & Accounting',
    description: 'Healthcare finance with blockchain, AI, data analytics, and regulatory compliance.',
    image: 'https://images.unsplash.com/photo-1716654716589-62219dcd47d3?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'BHA 101', name: 'Introduction to Health Accounting', credits: 3 },
          { code: 'BHA 102', name: 'Health Law and Regulations', credits: 3 },
          { code: 'BHA 201', name: 'Budgeting and Financial Planning', credits: 3 },
          { code: 'BHA 202', name: 'Blockchain in Healthcare Finance', credits: 3 },
          { code: 'BHA 204', name: 'AI in Healthcare Financial Management', credits: 3 },
          { code: 'BHA 307', name: 'Risk Assessment in Healthcare Finance', credits: 3 },
          { code: 'BHA 402', name: 'Capstone Project Preparation', credits: 3 },
        ]
      },
    ]
  },
  {
    id: 'bsc-ea',
    name: 'BSc in Environmental Accounting',
    shortName: 'BSc-EA',
    category: 'Finance & Accounting',
    description: 'Environmental finance, sustainability reporting, carbon trading, and ESG compliance.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
    semesters: [
      {
        name: 'Semester 1-8',
        title: 'Complete 8-Semester Curriculum',
        courses: [
          { code: 'BEA 101', name: 'Introduction to Environmental Accounting', credits: 3 },
          { code: 'BEA 102', name: 'Environmental Laws and Regulations', credits: 3 },
          { code: 'BEA 104', name: 'Sustainability Reporting', credits: 3 },
          { code: 'BEA 202', name: 'Blockchain and Carbon Credit Trading', credits: 3 },
          { code: 'BEA 204', name: 'AI in Sustainability Accounting', credits: 3 },
          { code: 'BEA 307', name: 'Risk Assessment in Environmental Finance', credits: 3 },
          { code: 'BEA 402', name: 'Capstone Project Preparation', credits: 3 },
        ]
      },
    ]
  },
];

export const programCategories = [
  'Health Sciences',
  'Environmental Sciences',
  'Education',
  'Agriculture',
  'Administration',
  'Finance & Accounting',
];
